const normalizeValue = value => {
  if (value === null || value === undefined) {
    return '';
  }
  return String(value).trim();
};

const PHONE_FIELDS = [
  ['homePhone', 'homePhone'],
  ['workPhone', 'workPhone'],
  ['cellPhone', 'cellPhone']
];

export default (otherInfo = {}, linkedGuest) => {
  if (!linkedGuest) {
    return true;
  }

  return PHONE_FIELDS.every(
    ([portalField, guestField]) =>
      normalizeValue(otherInfo[portalField]) ===
      normalizeValue(linkedGuest[guestField])
  );
};
